import { useQuery } from '@tanstack/react-query'
import { DeliverySubscription } from '../../../types/deliverySubscription/DeliverySubscription'
import { Contract } from '../../../types/contract/Contract'
import { fetchDeliveries } from '../service/deliverySubscriptionService'
import deliverySubscriptionQueryKeys from './deliverySubscriptionQueryKeys'

export const useDeliveries = (
  contractId: Contract['id'] | undefined,
  subscriptionId: DeliverySubscription['id'] | undefined
) => {
  return useQuery({
    queryKey: deliverySubscriptionQueryKeys.deliveries(contractId!, subscriptionId!),
    queryFn: () => fetchDeliveries(contractId!, subscriptionId!),
    enabled: !!contractId && !!subscriptionId
  })
}
